import { render, staticRenderFns } from "./educationCurriculum.vue?vue&type=template&id=0353085b"
import script from "./educationCurriculum.vue?vue&type=script&lang=js"
export * from "./educationCurriculum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0353085b')) {
      api.createRecord('0353085b', component.options)
    } else {
      api.reload('0353085b', component.options)
    }
    module.hot.accept("./educationCurriculum.vue?vue&type=template&id=0353085b", function () {
      api.rerender('0353085b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/educationCurriculum.vue"
export default component.exports